import consumer from "./consumer"

// Get the organization ID from the page
const organizationId = document.querySelector("[data-organization-id]")?.dataset.organizationId;

if (organizationId) {
  const subscription = consumer.subscriptions.create({
    channel: "OrgActivityChannel", 
    organization_id: organizationId
  }, {
      connected() {
    // Trigger the service call when connected
    this.loadActivityFeed();
  },
  
  disconnected() {
    // Called when the subscription has been terminated by the server
  },
    
    received(data) {
      
      const placeholder = document.getElementById("activity-feed-placeholder");
      const feedList = document.getElementById("activity-feed-list");
      const pagination = document.getElementById("activity-feed-pagination");

      if (data.status === "loading") {
        this.showLoadingState(data.message || "Loading activity feed");
      } else if (data.status === "complete" && data.html) {
        // Direct HTML from small orgs (synchronous)
        this.showContentState(data.html, data.pagination);
              } else if (data.status === "complete" && data.event_ids) {
          // Event IDs from small orgs (synchronous) - need to render
          this.renderEventsData(data.event_ids, data.page);
        } else if (data.status === "background_complete" && data.html) {
          // Old style background completion with HTML
          this.showContentState(data.html, data.pagination);
          this.showBackgroundCompleteNotice();
        } else if (data.status === "background_complete" && data.event_ids) {
          // New style background completion with event IDs - need to render
          this.renderEventsData(data.event_ids, data.page);
          this.showBackgroundCompleteNotice();
        } else if (data.status === "error" || data.status === "background_error") {
          this.showErrorState(data.error || "An error occurred while loading the activity feed.");
        }
    },

    showLoadingState(message) {
      const placeholder = document.getElementById("activity-feed-placeholder");
      const feedList = document.getElementById("activity-feed-list");
      const pagination = document.getElementById("activity-feed-pagination");
      
      // Show friendly loading state without technical details
      placeholder.innerHTML = `
        <div class="loading-skeleton">
          <div class="skeleton-text"></div>
          <div class="skeleton-text skeleton-short"></div>
          <div class="skeleton-text skeleton-medium"></div>
        </div>
        <p class="loading-message">📚 Loading recent activity...</p>
      `;
      placeholder.style.display = "";
      feedList.style.display = "none";
      pagination.style.display = "none";
    },

    showContentState(html, paginationHtml) {
      const placeholder = document.getElementById("activity-feed-placeholder");
      const feedList = document.getElementById("activity-feed-list");
      const pagination = document.getElementById("activity-feed-pagination");
      
      placeholder.style.display = "none";
      feedList.style.display = "";
      feedList.innerHTML = html;
      
      if (paginationHtml) {
        pagination.style.display = "";
        pagination.innerHTML = paginationHtml;
        this.addPaginationListeners();
      }
    },

    renderEventsData(eventIds, page) {
      // Make AJAX call to render events with proper session context
      fetch('/organization/render_activity_feed', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          event_ids: eventIds,
          page: page
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.showContentState(data.html, data.pagination);
        } else {
          this.showErrorState(data.error || "Failed to render activity feed");
        }
      })
      .catch(error => {
        console.error('❌ AJAX error:', error);
        this.showErrorState("Failed to render activity feed");
      });
    },

    showErrorState(errorMessage) {
      const placeholder = document.getElementById("activity-feed-placeholder");
      const feedList = document.getElementById("activity-feed-list");
      const pagination = document.getElementById("activity-feed-pagination");
      
      placeholder.innerHTML = `
        <div class="error-state">
          <p class="error-message">${errorMessage}</p>
          <div class="error-actions">
            <button class="button button-primary retry-btn" onclick="location.reload()">Try Again</button>
            <p class="support-message">
              Still having issues? Contact our support team at 
              <a href="mailto:orgs@teamtreehouse.com">orgs@teamtreehouse.com</a>
            </p>
          </div>
        </div>
      `;
      placeholder.style.display = "";
      feedList.style.display = "none";
      pagination.style.display = "none";
    },

    showBackgroundCompleteNotice() {
      // Subtle success indication without mentioning "background"
      const notice = document.createElement('div');
      notice.className = 'activity-loaded-notice';
      notice.innerHTML = '✅ Activity feed updated';
      document.body.appendChild(notice);
      
      setTimeout(() => {
        notice.remove();
      }, 2000);
    },

    addPaginationListeners() {
      const paginationButtons = document.querySelectorAll('.activity-page-btn');
      paginationButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          const page = e.target.dataset.page;
          if (page) {
            this.loadActivityPage(page);
          }
        });
      });
    },

    showError(message) {
      const placeholder = document.getElementById("activity-feed-placeholder");
      if (placeholder) {
        placeholder.textContent = message;
      }
    },

    loadActivityFeed() {
      // Check URL for page parameter, default to 1
      const urlParams = new URLSearchParams(window.location.search);
      const page = parseInt(urlParams.get('page')) || 1;
      this.makeActivityRequest(page);
    },

    loadActivityPage(page) {
      // Update URL to include page parameter
      const url = new URL(window.location);
      url.searchParams.set('page', page);
      window.history.pushState({}, '', url);
      
      this.makeActivityRequest(page);
    },

    makeActivityRequest(page) {
      fetch('/organization/load_activity_feed', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ page: page })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (data.background_processing) {
          // Show different message for background processing
          this.showLoadingState("📚 Loading recent activity...");
        }
        // Other success cases handled via ActionCable
      })
      .catch(error => {
        console.error('Error loading activity feed:', error);
        this.showErrorState("Error loading activity feed. Please try again.");
      });
    }
  });
}
